import React, { useState } from "react";
import {
  Box,
  ButtonStyled,
  ButtonStyledTb,
  FormButtonStyled,
  FormEleWrapper,
  HeadingStyled,
  LabelStyled,
  SubHeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { Camera, ProfileImgLarge } from "../../../components/styled/AllImages";
import { ProfileEditContainer } from "./styled";
import { Col, Form, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import {
  cityList,
  OperateList,
  ProvinceList,
} from "../../../helpers/dummyConstants";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import UsersApi from "../../../services/api/usersApi";
import { toast } from "react-toastify";

const ChangePasswordForm = () => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const onSubmit = async (dataObj) => {
    try {
      setLoading(true);
      const { code, message, error } = await UsersApi.changePassword(dataObj);
      if (code === 200) {
        toast.success(t("password_changed_successfully"));
        reset();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
      if (code === 422) {
        toast.error(error);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <ProfileEditContainer>
        <HeadingStyled size="24px" className="editProfileHeading">
          {t("ChangePassword")}
        </HeadingStyled>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="profileFormContainerInner">
            <Row className="mt-3">
              <Col md={12}>
                <ValidatedInput
                  name="old_password"
                  label={"OldPassword"}
                  type="input"
                  fieldType="password"
                  placeholder={"OldPassword"}
                  className={"mb-3 combined flex-wrap p-0"}
                  bg="var(--white)"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                    minLength: {
                      value: 8,
                      message: "lengthGreaterThen",
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="password"
                  label={"new_password"}
                  type="input"
                  fieldType="password"
                  placeholder={"new_password"}
                  className={"mb-3 combined flex-wrap p-0"}
                  bg="var(--white)"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                    minLength: {
                      value: 8,
                      message: "lengthGreaterThen",
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="password_confirmation"
                  label={"confirm_new_password"}
                  type="input"
                  fieldType="password"
                  placeholder={"confirm_new_password"}
                  className={"mb-3 combined flex-wrap p-0"}
                  bg="var(--white)"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                    validate: (value) =>
                      value === watch("password") || "password_do_not_match",
                  }}
                />
              </Col>
            </Row>
            <Box className="formBtns">
              <ButtonStyledTb
                className="nextStepBtn"
                type="button"
                bg="var(--white)"
                border="var(--border)"
                color="var(--darkGrey)"
                onClick={() => navigate("/my-profile")}
              >
                {t("Cancel")}
              </ButtonStyledTb>
              <FormButtonStyled
                type="submit"
                label={t("Update")}
                disabled={loading}
                isLoading={loading}
                bg="var(--themeColorSecondary)"
              />
            </Box>
          </Box>
        </Form>
      </ProfileEditContainer>
    </>
  );
};

export default ChangePasswordForm;
